import { useNavigate as useRouterNavigate, NavigateOptions, To } from 'react-router-dom';
import { useCallback } from 'react';

type NavigateFn = {
    (delta: number): void;
    (to: To, options?: NavigateOptions): void;
};

/**
 * Drop-in replacement for React Router's useNavigate.
 * Returns a stable (memoized) navigate function.
 *
 * View transitions are handled by CSS `@view-transition { navigation: auto }`
 * in index.css — this avoids React Router's flushSync which conflicts with
 * Ant Design Tabs' ResizeObserver and causes infinite setState loops.
 */
export function useNavigate(): NavigateFn {
    const routerNavigate = useRouterNavigate();

    return useCallback(
        (to: To | number, options?: NavigateOptions) => {
            if (typeof to === 'number') {
                routerNavigate(to);
            } else {
                routerNavigate(to, options);
            }
        },
        [routerNavigate],
    ) as NavigateFn;
}
